<template>
  <div class="UnderMaintenance">
    <div class="imgContain">
      <img src="../assets/images/working.png" alt="" />
    </div>
    <div class="word">系统正在维护，请稍后再试</div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.UnderMaintenance {
  background-color: #ffffff;
  padding-top: 14.5rem;
}
.imgContain {
  display: flex;
  justify-content: center;
  img {
    width: 34.75rem;
    height: 21.125rem;
  }
}
.word {
  color: #338989;
  font-size: 2.125rem;
  line-height: 3.125rem;
  text-align: center;
  margin-top: 3.125rem;
}
</style>